import React from 'react';
import styles from '@/styles/components/question-builders/QuestionPreviewContent.module.css';
import {
  ScreenerPurposeElement,
  ScreenerPurposeElementData,
} from '../ScreenerPurposeElement';

export interface ScreenerPreviewContentData extends ScreenerPurposeElementData {
  questionText: string | null;
}

export const ScreenerPreviewContent: React.FC<
  ScreenerPreviewContentData
> = props => {
  return (
    <div className={styles.questionContentWrapper}>
      <div className={styles.questionContent}>
        <span className={styles.title}>Survey Question</span>
        <span className={styles.text}>{props.questionText}</span>
      </div>
      <div className={styles.questionType}>
        <span className={styles.title}>Screener Purpose</span>
        <ScreenerPurposeElement {...props} isFullHeight={false} />
      </div>
    </div>
  );
};
